module.exports = __webpack_public_path__ + "static/media/CITIZEN.d24e52ec.svg";